/**
 * Mermaid `sequenceDiagram` → DiagramData, matching the other importers' shape
 * (`{ data, warnings }`). Composes the parser (text → model) with the
 * deterministic layout (model → positioned DiagramData). NO dagre.
 */

import type { DiagramData } from '../types/schema'
import { parseSequenceMermaid } from './mermaidSequence'
import { buildSequenceDiagram } from './sequenceLayout'

export interface MermaidSequenceImportResult {
  data: DiagramData
  warnings: string[]
}

export function parseMermaidSequenceDiagram(text: string): MermaidSequenceImportResult {
  const { model, warnings } = parseSequenceMermaid(text)
  return { data: buildSequenceDiagram(model), warnings }
}
